import moment from '../utils/moment'

export default {
  install (app) {
    app.config.globalProperties.$dateFormat = (value, format) => {
      if (!value) {
        return ''
      }
      const m = moment(value)
      return m.isValid() ? m.format(format) : ''
    }
  }
}
